var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBlocked = function SvgBlocked(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39069 24.2773L24.2773 2.3907C24.8166 1.85141 25.691 1.85141 26.2303 2.3907L48.1169 24.2773C48.6562 24.8166 48.6562 25.691 48.1169 26.2303L26.2303 48.1169C25.691 48.6562 24.8166 48.6562 24.2773 48.1169L2.39069 26.2303C1.8514 25.691 1.8514 24.8166 2.39069 24.2773Z",
    fill: "#FE7A00",
    stroke: "#CD2500",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25C14.5 30.7989 19.2011 35.5 25 35.5C30.7989 35.5 35.5 30.7989 35.5 25C35.5 19.2011 30.7989 14.5 25 14.5C19.2011 14.5 14.5 19.2011 14.5 25ZM17.3182 25C17.3182 20.7534 20.7534 17.3182 25 17.3182C29.2466 17.3182 32.6818 20.7534 32.6818 25C32.6818 29.2466 29.2466 32.6818 25 32.6818C20.7534 32.6818 17.3182 29.2466 17.3182 25Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.736 30.0438L17.3825 30.3974L17.736 30.7509L19.0217 32.0366L19.3752 32.3901L19.7288 32.0366L32.2637 19.5016L32.6173 19.1481L32.2637 18.7945L30.9781 17.5089L30.6245 17.1553L30.271 17.5089L17.736 30.0438Z",
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blocked.61d71a85.svg";
export { ForwardRef as ReactComponent };